var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrap-item" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "sk-dialog__footer flex justify-end items-center" },
      [
        _c(
          "el-dropdown",
          {
            attrs: { trigger: "click" },
            on: { command: _vm.handleExportCommand },
          },
          [
            _c(
              "el-button",
              {
                staticStyle: { "min-width": "110px" },
                attrs: { type: "success" },
              },
              [
                _vm._v("\n        Tác vụ "),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
              ]
            ),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                _c("el-dropdown-item", { attrs: { command: "constitutive" } }, [
                  _c("i", { staticClass: "el-icon-setting" }),
                  _vm._v(" Thiết lập đơn xin nghỉ\n        "),
                ]),
                _c(
                  "el-dropdown-item",
                  { attrs: { command: "reason-config" } },
                  [
                    _c("i", { staticClass: "el-icon-notebook-2" }),
                    _vm._v(" Thiết lập lý do nghỉ\n        "),
                  ]
                ),
                _c(
                  "el-dropdown-item",
                  { attrs: { command: "approve-multi" } },
                  [
                    _c("i", { staticClass: "el-icon-check" }),
                    _vm._v(" Duyệt đơn\n        "),
                  ]
                ),
                _c("el-dropdown-item", { attrs: { command: "delete-multi" } }, [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _vm._v(" Xoá đơn\n        "),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "margin-bottom": "12px" } }, [
      _c("p", { staticClass: "card-title" }, [_vm._v("Tác vụ")]),
      _c("p", { staticClass: "card-subtitle" }, [
        _vm._v("Thiết lập cấu hình, duyệt nhiều đơn xin nghỉ"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }